import instance from "../utils/request.js"
import { getRequest } from "../utils/request.js"

/*获取报价信息*/
export function GetQuote(data = {}){
return instance.request({
        method: "get",
        url: "basicdata/quote/",
        params:data
    })
}


/*获取报价编辑信息*/
export function QuoteEditInfo(data = {}){
return instance.request({
        method: "get",
        url: "basicdata/quoteedit/",
        params:data
    })
}

/*报价编辑*/
export function QuoteEdit(data = {}){
    let params = new URLSearchParams();
    params.append('pictureid',data.pictureid);
    params.append('laborcosts_income',data.laborcosts_income);
    params.append('laborcosts_expenditure',data.laborcosts_expenditure);
    params.append('copyfee_income',data.copyfee_income);
    params.append('copyfee_expenditure',data.copyfee_expenditure);
     params.append('samplefee_income',data.samplefee_income);
    params.append('samplefee_expenditure',data.samplefee_expenditure);
    params.append('profit',data.profit);
    params.append('fixedpricetag',data.fixedpricetag);
    params.append('fixedprice',data.fixedprice);
     params.append('notes',data.notes);
    params.append('sampleweight',data.sampleweight);
return instance.request({
        method: "post",
        url: "basicdata/quoteedit/",
        data:params
    })
}


/*获取所有角色信息*/
export function CategoryInfo(data = {}){
return instance.request({
        method: "get",
        url: "basicdata/categoryoptions/",
        params:data
    })
}

/*报价删除*/
export function QuoteDel(data = {}){
    let params = new URLSearchParams();
    params.append('quoteid',data.quoteid)
return instance.request({
        method: "post",
        url: "basicdata/quotedel/",
        data:params
    })
}

/*报价新增*/
export function QuoteAdd(data){
return instance.request({
        method: "post",
        url: "basicdata/quoteadd/",
        data:data
    })
}

/*获取报价记录信息*/
export function QuoteInfo(data = {}){
return instance.request({
        method: "get",
        url: "basicdata/getquote/",
        params:data
    })
}

/*获取报价附件信息*/
export function QuoteattachmentInfo(data = {}){
return instance.request({
        method: "get",
        url: "basicdata/quoteattachment/",
        params:data
    })
}

/*上传报价附件*/
export function UploadQuoteattachment(data = {}){
return instance.request({
        method: "post",
        url: "basicdata/quoteattachmentupload/",
        data:data
    })
}

/*报价附件删除*/
export function QuoteattachmentDel(data = {}){
    let params = new URLSearchParams();
    params.append('quoteattachmentid',data.quoteattachmentid)
return instance.request({
        method: "post",
        url: "basicdata/quoteattachmentdel/",
        data:params
    })
}

export function QuoteEditRecordInfo(data = {}){
return instance.request({
        method: "get",
        url: "basicdata/quoterecordedit/",
        params:data
    })
}

/*报价编辑*/
export function QuoteRecordEdit(data = {}){
    let params = new URLSearchParams();
    params.append('quoterecordid',data.quoterecordid);
    params.append('material',data.material);
    params.append('fixedprice',data.fixedprice);
    params.append('electroplate',data.electroplate);
    params.append('chain',data.chain);
     params.append('gemquality',data.gemquality);
    params.append('laborcost',data.laborcost);
     params.append('notes',data.notes);
return instance.request({
        method: "post",
        url: "basicdata/quoterecordedit/",
        data:params
    })
}

/*复制报价*/
export function QuoteCopy(data = {}){
let params = new URLSearchParams();
    params.append('quoteid',data.quoteid)
return instance.request({
        method: "post",
        url: "basicdata/quotecopy/",
        data:params
    })
}